import Sitekit from 'sitekit'

let Site = new Sitekit()

// Promisify Site.callAPI
const oldCallAPI = Site.callAPI
Site.callAPI = (method, args) =>
  new Promise(resolve =>
    oldCallAPI(method, args, (error, data) => resolve({ error, data }))
  )

Site.startWidgets = function() {
  // Run widget functions
  const widgets = require.context('./widgets', false, /\.js$/)
  widgets.keys().forEach(id => {
    const module = widgets(id)
    const call = module.default ? module.default : module
    if (typeof call === 'function') call(Site, Site.$)
  })
}

// Configure sitekit based on admin/not
if (window.location.href.match(/wp-admin/)) {
  Site.isAdmin = true
  Site.xhrOptions.xhrEnabled = false
} else {
  window.$ = Site.$
  window.Site = Site
}

Site.xhrOptions.scrollAnimation = false
Site.xhrOptions.autoScrollRestore = false

Site.xhrOptions.swapContent = async (container, oldEl, newEl, direction) => {
  const parent = container.parent()

  const dir = direction === 'forward' ? 1 : -1
  const mobile = $(window).width() < 700 ? 0.5 : 1

  // Remove old el
  await transition({
    target: parent,
    opacity: 0,
    x: -30 * dir * mobile,
    rotateZ: '6deg',
    duration: 300,
    easing: 'easeInQuad',
  })

  oldEl.remove()

  container.append(newEl).show()
  newEl.show()

  window.scrollTo(0, 0)
  await Site.restoreScroll()

  parent.css({
    opacity: 0,
    x: 10 * dir * mobile,
    rotateZ: '-6deg',
  })

  await transition({
    target: parent,
    opacity: 1,
    x: 0,
    rotateZ: '0deg',
    duration: 600,
    delay: 300,
    easing: 'easeOutQuad',
  })
}

function transition(options, time = false) {
  const { target, ...opts } = options

  return new Promise(resolve => {
    if (typeof time === 'number') {
      setTimeout(resolve, time)
      target.transition(opts)
    } else {
      target.transition(opts, resolve)
    }
  })
}

export const $ = Site.$
export default Site
